import { DirectiveOptions } from 'vue';

/**
 * Marca um elemento (e, por herança, seus descendentes) como não-traduzível.
 *
 * Por que uma diretiva em vez de escrever `translate="no"` no template: o Vue 2 tem
 * `translate` na sua lista de `isBooleanAttr`, então ele renderiza `translate="translate"`
 * em vez de `translate="no"`. Pelo spec do HTML, valor inválido no atributo `translate`
 * significa **herdar** — ou seja, escrever direto no template compila para algo que
 * silenciosamente NÃO protege nada. Setar via DOM contorna o serializador do Vue.
 *
 * `inserted` (e não `bind`) porque os dropdowns vivem dentro de `<transition v-if>`:
 * são criados e destruídos a cada abertura, e a diretiva precisa rodar de novo em cada
 * inserção.
 *
 * A classe `notranslate` vai junto: é o sinal legado que o Google Translate respeita, e
 * cobre browser que ignore o atributo.
 */
const notranslate: DirectiveOptions = {
  inserted(el: HTMLElement) {
    el.setAttribute('translate', 'no');
    el.classList.add('notranslate');
  },
};

export default notranslate;
